import { useEffect, useState } from "react";
import axios from "../helpers/axios";

// Create a cart
export const createCart = async (values, callback) => {
  const res = await axios.post(`/cart/createcart`, values);
  callback(res.data.response);
};

// Update a cart by ID
export const updateCart = async (id, values, callback) => {
  const res = await axios.put(`/cart/updatecart/${id}`, values);
  callback(res.data.response);
};

// Delete a cart by ID
export const deleteCart = async (id, callback) => {
  const res = await axios.delete(`/cart/deletecartbyid/${id}`);
  callback(res.data.response);
};

// Delete all cart items for a specific customer
export const deleteAllCart = async (customerId, callback) => {
  const res = await axios.delete(`/cart/deleteallcart/${customerId}`);
  callback(res.data.response);
};

// Get cart items for a specific customer
export const getCustomerCart = async (customerId, callback) => {
  const res = await axios.get(`/cart/getcustomercart/${customerId}`);
  callback(res.data.response);
};

// Get all cart items
export const getAllCart = async (callback) => {
  const res = await axios.get(`/cart/`);
  callback(res.data.response);
};

// Cart API Hook for managing state
export const CartAPI = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartDetail, setCartDetail] = useState({});
  const [callback, setCallback] = useState(false);
  const [customerId, setCustomerId] = useState(0);

  useEffect(() => {
    getAllCart((res) => {
      setCartItems(res);
    });

    if (customerId) {
      getCustomerCart(customerId, (res) => {
        setCartItems(res);
      });
    }
  }, [callback, customerId]);

  return {
    cartItems: [cartItems, setCartItems],
    cartDetail: [cartDetail, setCartDetail],
    callback: [callback, setCallback],
    customerId: [customerId, setCustomerId],
  };
};
